module.exports = __webpack_public_path__ + "static/media/check.eab0728e.svg";